export default __webpack_public_path__ + "static/media/next-hover.71169c5e.svg";